import { ShortBreakType } from 'app/constants/configuration/shortBreakType'

export const getShortBreakType = (type: number): ShortBreakType => {
  switch (type) {
    case 1:
      return ShortBreakType.LaborCode
    default:
      return ShortBreakType.DriversWorkingHours
  }
}
